import React, { useState } from 'react';
import aboutImg1 from '../img/gallery-1.jpeg';
import aboutImg2 from '../img/gallery-2.jpeg';
import aboutImg3 from '../img/gallery-3.jpeg';
import aboutImg4 from '../img/gallery-4.jpeg';
import EnquiryModal from './EnquiryModal';

const About = () => {
     const [showModal, setShowModal] = useState(false);
  return (
    <div className="container-fluid about py-5">
      <div className="container py-5">
        <div className="row g-5 align-items-center">
          {/* Left Image Section */}
          <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.1s">
            <div className="about-item-image d-flex">
              <img src={aboutImg1} alt="About 1" className="img-1 img-fluid w-50" />
              <img src={aboutImg2} alt="About 2" className="img-2 img-fluid w-50" />
              <div className="about-item-image-content">
                <img
                  src={aboutImg3}
                  alt="About 3"
                  className="img-fluid w-100 h-100"
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.1s">
            <div className="about-item-content">
              <p className="text-uppercase text-secondary fs-5 mb-1">
                We Are a Trusted Construction Company
              </p>

              {/* Subtitle */}
              <h6 className="text-muted mb-2">
                A Benchmark in Commercial Excellence
              </h6>

              {/* Main Title */}
              <h2 className="display-4 text-capitalize mb-3">
                Emperia Icon by Emperia Projects, Nerul
              </h2>

              {/* Paragraph */}
              <p className="mb-4 fs-5">
                Emperia Icon is a landmark commercial development in the heart of Nerul, Navi Mumbai. With modern architecture, top-tier amenities, and smart design, it offers premium office spaces tailored for ambitious businesses. Built with precision and excellence, Emperia Icon reflects our commitment to quality and innovation.
              </p>

              {/* Inner Image and Text */}
              <div className="pb-4 mb-4 border-bottom">
                <div className="row g-4">
                  <div className="col-lg-4">
                    <div className="about-item-content-img">
                      <img src={aboutImg4} alt="About 4" className="img-fluid w-100" />
                    </div>
                  </div>
                  <div className="col-lg-8">
                    <div className="d-flex mb-4">
                      <div className="text-secondary">
                        <i className="fas fa-user-shield fa-3x"></i>
                      </div>
                      <h4 className="ms-3">Building Quality Standards</h4>
                    </div>
                    <div className="d-flex">
                      <div className="text-secondary">
                        <i className="fas fa-users-cog fa-3x"></i>
                      </div>
                      <h4 className="ms-3">No .1 Developer Brand</h4>
                    </div>
                  </div>
                </div>
              </div>

              {/* Features list */}
              <div className="row gy-0 gx-4 justify-content-between pb-4">
                <div className="col-lg-6">
                  <p className="text-dark">
                    <i className="fas fa-check text-secondary me-1"></i> Highest ROI Investment
                  </p>
                  <p className="text-dark">
                    <i className="fas fa-check text-secondary me-1"></i> Fastest Growing Location
                  </p>
                </div>
                <div className="col-lg-6">
                  <p className="text-dark">
                    <i className="fas fa-check text-secondary me-1"></i>  World-class Development
                  </p>
                  <p className="text-dark mb-0">
                    <i className="fas fa-check text-secondary me-1"></i> Open To Expand Your Investment Horizon
                  </p>
                </div>
              </div>

              {/* Button */}
              <button
              
                className="btn btn-secondary d-inline-block py-3 px-5 me-2 flex-shrink-0 wow fadeInUp"
                data-wow-delay="0.1s"
                 onClick={() => setShowModal(true)}
              >
                Discover More
              </button>

              
            </div>
          </div>
        </div>
      </div>
      <EnquiryModal show={showModal} onClose={() => setShowModal(false)} formtitle={" Discover More"} />
    </div>
  );
};





 






export default About;
